import { AddChallengeToPatientPayload } from '_api/types';
import dayjs from 'dayjs';

const DefaultAddChallengeToPatientSettings: AddChallengeToPatientPayload = {
  contentId: 0,
  regimenType: 'HABIT',
  reps: 1,
  sets: 1,
  perDay: 1,
  perWeek: 1,
  schedule: ['M'],
  patientId: 0,
  instructionList: [],
  defaultTargetSide: 'NA',
  assignedDate: dayjs().format('YYYY-MM-DD'),
};

export default DefaultAddChallengeToPatientSettings;
